import { render, staticRenderFns } from "./donut-transaction-by-pg.vue?vue&type=template&id=efaa19d4&"
import script from "./donut-transaction-by-pg.vue?vue&type=script&lang=js&"
export * from "./donut-transaction-by-pg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports